import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { withTheme } from 'styled-components';
import { connect } from 'react-redux';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { MainContent } from '@finect/tabular-core/MainContent';
import { FundTopYTDFunds, FundMostViewedFunds, FundSectorsCarousel, FundSRRICarousel } from '@finect/tabular-components/Modules';
import { VideosCarousel } from '@finect/tabular-components/Videos';
import { H1 } from '@finect/tabular-core/Headings';
import { DatalayerScene } from '@finect/front-gtm';
import { Head } from '@finect/tabular-components/Head';
import { withSubscriptions } from '@finect/front-core/User';
import { getProductTypeLabel, getProductTypeBySlug, getFundsHomePath } from '@finect/front-resources/Products';
import { StorefrontsCarousel } from '@finect/tabular-components/Storefronts';
import { modelizeVideo } from '../commons/videos';
import { fetchIICHomeInitialData, clearIICHome } from '../commons/IIC/actions/thunks';
import { FamilyInsideNavigation, ProductFamilyContents, GlobalBanks, MoreSections, SectionBlockContent, SectionBlock } from '../commons/IIC/components';
import { sections } from './utils';
const mapStateToProps = state => ({
  user: state.user.user,
  status: state.fund.homeStatus,
  fundsByYTD: state.fund.fundsByYTD,
  fundsMostViewed: state.fund.mostViewed,
  companies: state.fund.companies,
  storeFrontArticles: state.products.storeFrontArticles,
  tags: state.content.tags,
  contentHash: state.content.hash,
  storefronts: state.products.storefronts
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchIICHomeInitialData,
    clearIICHome
  }, dispatch)
});
class FundsHome extends React.Component {
  static loadInitialData(store, cookies, match) {
    const productType = getProductTypeBySlug('fondos-inversion');
    return store.dispatch(fetchIICHomeInitialData({
      productType
    }));
  }
  componentDidMount() {
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    if (productType.id !== this.props.status) {
      this.props.actions.fetchIICHomeInitialData({
        productType
      });
    }
  }
  componentWillUnmount() {
    this.props.actions.clearIICHome();
  }
  render() {
    const {
      theme,
      storefronts,
      companies,
      storeFrontArticles,
      fundsMostViewed,
      subscriptions,
      fundsByYTD
    } = this.props;
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    const tag = this.props.tags.find(item => item.model.alias === productType.tag);
    const pluralLowercase = getProductTypeLabel(productType, 'plural', 'lowercase');
    return React.createElement(React.Fragment, null, React.createElement(Head, {
      title: `${productType.plural}`,
      description: `Descubre y compara entre los mejores ${pluralLowercase}, consulta nuestros rankings y conoce las opiniones de otros inversores`,
      canonical: getFundsHomePath(theme, productType)
    }), React.createElement(DatalayerScene, {
      pageType: "home",
      pageId: productType.api
    }), React.createElement(Container, null, React.createElement(FamilyInsideNavigation, {
      current: "home",
      productType: productType
    }), React.createElement(ContainerInner, null, React.createElement(MainContent, {
      fullWidth: true,
      style: {
        marginTop: '60px'
      }
    }, React.createElement("header", {
      style: {
        marginBottom: '32px'
      }
    }, React.createElement(H1, {
      large: true
    }, productType.plural)), React.createElement(ProductFamilyContents, {
      productType: productType
    }), React.createElement(FundSRRICarousel, {
      productType: productType
    }), React.createElement(FundSectorsCarousel, {
      productType: productType
    }), React.createElement(VideosCarousel, {
      fetched: !tag ? false : tag.videos.fetched,
      fetching: !tag ? true : tag.videos.fetching,
      title: `${productType.plural} en modo vídeo`,
      videos: tag ? tag.videos.items.map(item => modelizeVideo(item)) : []
    }), React.createElement(FundMostViewedFunds, {
      withSPA: true,
      productType: productType,
      funds: fundsMostViewed,
      subscriptions: subscriptions.products,
      onFollow: (id, status) => this.props.handleEntityFollow('product', 'subscribe', id, status)
    }), React.createElement(FundTopYTDFunds, {
      withSPA: true,
      productType: productType,
      funds: fundsByYTD,
      subscriptions: subscriptions.products,
      onFollow: (id, status) => this.props.handleEntityFollow('product', 'subscribe', id, status)
    }), React.createElement(StorefrontsCarousel, {
      storefronts: storefronts
    }), React.createElement(GlobalBanks, {
      banks: companies,
      productType: productType,
      isPartner: true
    }), ['finect'].includes(theme.partner.consumer) ? React.createElement(MoreSections, {
      sections: sections
    }) : null))), tag && (storeFrontArticles || []).map((article, index) => React.createElement(SectionBlockContent, {
      key: index
    }, React.createElement(SectionBlock, {
      article: article,
      tag: tag.model,
      index: index
    }))));
  }
}
export default withSubscriptions(connect(mapStateToProps, mapDispatchToProps)(withTheme(FundsHome)), ['products']);